"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var axios_1 = require("axios");
var resource = /** @class */ (function () {
    function resource() {
    }
    resource.prototype.makeRequest = function (request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var axiosPromise, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!request.paramsSerializer) {
                            request.paramsSerializer = bugzillaParamSerializer;
                        }
                        axiosPromise = resource.axios(request);
                        axiosPromise.catch(this.handleError);
                        return [4 /*yield*/, axiosPromise];
                    case 1:
                        result = _a.sent();
                        if (result.data.error) {
                            throw new Error("Error returned without propper error code, see below \n " + JSON.stringify(result.data));
                        }
                        if (result) {
                            return [2 /*return*/, result.data];
                        }
                        // Rrrors should always be caught above.
                        // if result is undefined, something is very wrong.
                        throw new Error('Something went wrong');
                }
            });
        });
    };
    /**
     * Function too handle and throw readable errors from this.axios.
     *
     * @param {this.axiosError} error -
     */
    resource.prototype.handleError = function (error) {
        if (error.response) {
            console.log(error.response.request.path); // debugging 
            throw new Error(error.response.data.message);
        }
    };
    resource.axios = axios_1.default;
    return resource;
}());
exports.resource = resource;
// Bugzilla is super weird and inconsistant about how it wants it's params passing, 
// especially if arrays are involved. 
// this is the way that gets the request to pass in MOST but not ALL circumstance. 
/**
 *
 *
 * @param params
 */
function bugzillaParamSerializer(params) {
    var paramString = '';
    Object.keys(params).forEach(function (key) {
        if (Array.isArray(params[key])) {
            var str_1 = '';
            params[key].forEach(function (element) {
                str_1 += "&" + key + "=" + element;
            });
            paramString += str_1;
        }
        else {
            paramString += "&" + key + "=" + params[key];
        }
    });
    return encodeURI(paramString);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/resource.js
// module id = 67
// module chunks = 0